import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import plugins from '../plugins/plugins.js'

export default async (uri) => {
  const { path } = plugins
  const [promise, { resolve, reject }] = resolvable()

  path.resolveNativePath(uri, f => resolve(f), reject)

  return promise
}
